import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IVendedor, IVendedorTPF } from '../models/vendedor.model';

@Injectable()
export class VendedorService extends EntityService<IVendedor> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'vendedor',
      pluralBaseEntityEndPoint: 'vendedores'
    });
  }

  /**
   * Pega clientes disponiveis para um vendedor e retorna eles paginados
   * @param vendedor_id
   * @param pagination
   * @param include
   * @param where
   * @returns
   */
  clientesCarteira(
    vendedor_id: string,
    pagination: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    include: string[],
    domain_id: string,
    where?: string | { field: string; value: string },
    getSelecionados = false,
  ) {
    var url = getSelecionados
      ? `${this.baseURL}/${vendedor_id}/clientes`
      : `${this.baseURL}/${vendedor_id}/clientes_disponiveis`;
    var params = new HttpParams();

    if (pagination) {
      params = params
        .append('page', pagination.page)
        .append('page_size', pagination.page_size)
        .append('require_pagination', pagination.require_pagination);
    }

    if (include) params = params.append('include', include.join(','));

    if (where) {
      if (typeof where === 'object' && where.value && Object.keys(where).length !== 0)
        params = params.append(`${where.field}`, where.value);
      else if (typeof where === 'string')
        params = params.append('pre_cadastro_id', where);
    }

    if (domain_id) params = params.append('domain_id', domain_id);
    // params = params.append('order_by', 'parceiro.apelido_nome_fantasia');

    return this.http.get<any>(url, {
      params: params,
      headers: this.getHeader()
    });
  }

  /**
   * Pega TPFs disponiveis para um vendedor e retorna eles paginados
   * @param vendedor_id
   * @param pagination
   * @param include
   * @param where
   * @returns
   */
  vendedorTpfDisponiveis(
    vendedor_id: string,
    pagination: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    include: string[],
    domain_id: string,
    where?: string | any
  ) {
    const url = `${this.baseURL}/${vendedor_id}/tpf_disponiveis`;
    var params = new HttpParams();

    if (pagination) {
      params = params
        .append('page', pagination.page)
        .append('page_size', pagination.page_size)
        .append('require_pagination', pagination.require_pagination);
    }

    if (include) params = params.append('include', include.join(','));

    if (domain_id) params = params.append('domain_id', domain_id);

    if (where) {
      if (typeof where === 'object' && Object.keys(where).length !== 0) {
        Object.keys(where).forEach(k => {
          if(where[k])
            params = params.append(k, where[k]);
        });
      } else params = params.append('tabela_preco_fabrica_id', where);
    }

    return this.http.get<any>(url, {
      params: params,
      headers: this.getHeader()
    });
  }

  /**
   * Aciona a requisição de adição de uma TPF disponível para um vendedor
   * @param vendedor_id
   * @param tpf_id
   * @returns
   */
  addTpfProVendedor(vendedor_id: string, tpf_id: string) {
    const url = `${this.baseURL}/${vendedor_id}/tabelas_preco_fabrica/${tpf_id}`;
    const body = {
      vendedor_id,
      tabela_preco_fabrica_id: tpf_id
    } as IVendedorTPF;
    const headers = this.getHeader();

    return this.http.put<any>(url, body, { headers });
  }

  /**
   * Aciona a requisição de remoção de uma TPF selecionada para um vendedor
   * @param vendedor_id
   * @param tpf_id
   * @returns
   */
  rmTpfProVendedor(vendedor_id: string, tpf_id: string) {
    const url = `${this.baseURL}/${vendedor_id}/tabelas_preco_fabrica/${tpf_id}`;
    const headers = this.getHeader();

    return this.http.delete<any>(url, { headers });
  }
}
